import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button } from "react-md";
import { DataTable, TableHeader, TableBody, TableRow, TableColumn, EditDialogColumn, SelectFieldColumn } from "react-md/lib/DataTables";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { checkIfEmpty, dateTimeToString } from "components/Shared/Formatters";
import { cloneDeep, isEqual } from "lodash";

function getStatus(status) {
  const statuses = {
    0: "Not available for this appraisal.",
    1: "Request has not been submitted yet.",
    2: "Changes have occurred since the last request.",
    3: "Pending result.  Please wait.",
    4: "Request completed ",
  };
  return statuses[status];
}

class IssuesList extends Component {
  constructor(props) {
    super(props);
    this.allowOverrideComment = this.allowOverrideComment.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.openCard = this.openCard.bind(this);
    this.state = {
      items: [],
      invalid: false,
      pristine: true,
      submitting: false,
      collapsed: true
    };

    this.ref = React.createRef();
  }

  UNSAFE_componentWillMount () {
    let items = cloneDeep(this.props.items);
    // initialize the editable setting (Override comments required on certain options)
    let needsResolveDate = false;
    items.forEach((item) => {
      item.editable = this.allowOverrideComment(item);
      needsResolveDate |= (item.selectedVerosOverrideTypeId && !item.resolvedDate);
    });

    if (needsResolveDate) {
      this.setState({items: items, pristine: false });
    } else {
      this.setState({items: items});
    }

    if (this.props.getControlMethods) {
      this.props.getControlMethods({ ref: this.ref, openCard: this.openCard });
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.items) {
      const itemsChanged = !isEqual(nextProps.items, this.props.items);
      if (itemsChanged) {
        let items = cloneDeep(nextProps.items);
        // initialize the editable setting (Override comments required on certain options)
        let needsResolveDate = false;
        items.forEach((item) => {
          item.editable = this.allowOverrideComment(item);
          needsResolveDate |= (item.selectedVerosOverrideTypeId && !item.resolvedDate);
        });
    
        if (needsResolveDate) {
          this.setState({items: items, pristine: false });
        } else {
          this.setState({items: items});
        }
      }
    }
  }

  allowOverrideComment(item) {
    let editable = false;
    if (item && item.choices.length > 0) {
      item.choices.forEach((c) => {
        if (c.id === item.selectedVerosOverrideTypeId) {
          editable = c.commentRequired === true;
        }
      });
    }
    return editable;
  }

  onSubmit(e) {
    e.preventDefault();
    const items = this.state.items;
    this.setState({submitting: true});
    if (!this.state.invalid) {
      // do it
      this.props.handleSubmit(items);
    } else {
      // toast it up
    }
    this.setState({submitting: false, pristine: true});
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  openCard() {
    this.setState({ collapsed: false });
  }

  changedOverrideType(rowId, val) {
    setTimeout(() => {
      const items = this.state.items;
      let currentItem = null;
      let currentChoice = null;
      items.forEach((item) => {
        if (item.id === rowId) {
          currentItem = item;
        }
      });
      if (currentItem != null) {
        currentItem.choices.forEach((c) => {
          if (c.id === val) {
            currentChoice = c;
          }
        });
      }
      if (currentItem.selectedVerosOverrideTypeId !== currentChoice.id) {
        currentItem.editable = (currentChoice.commentRequired === true);
        currentItem.selectedVerosOverrideTypeId = currentChoice.id;
        this.setState({items: items, pristine: false });
      }
    }, 500);
  }

  changedOverrideComment(rowId, val) {
    setTimeout(() => {
      const items = this.state.items;
      let currentItem = null;
      items.forEach((item) => {
        if (item.id === rowId) {
          currentItem = item;
        }
      });
      if (currentItem.selectedOverrideComment !== val) {
        currentItem.selectedOverrideComment = val;
        this.setState({items: items, pristine: false });
      }
    }, 500);
  }
  
  buildMenu(choiceList) {
    let menuItems = [];
    choiceList.map((c) => {
      menuItems.push({
        key: c.id,
        label: c.name,
        value: c.id
      });
    });
    return menuItems;
  }

  getChoice(choices, id, severity) {
    if (choices.length === 0) {
      if(severity !== "Hard Stop") {
        return <span className="veros-no-override-message">Override automatically approved.</span>;
      } else {
        return <span className="veros-no-override-message">Override or fix may be required.</span>;        
      }
    }
    if (choices.length === 1) {
      return choices[0];
    }
    return choices.find((item) => {
      return item.id === id;
    });
  }

  
  render() {
    const { readOnly, status, date, title } = this.props;
    const { invalid, pristine, submitting, items } = this.state;

    return (
      <div className="case-header" ref={this.ref}>
        <Card className="md-cell md-cell--12"
          expanded={!this.state.collapsed}
          onExpanderClick={this.toggle}>
          <CardTitle 
            title={title} 
            style={{cursor: "pointer"}}
            expander
            onClick={this.toggle} />
            <CardText expandable>
              {items.length
              ? 
                <div className="veros-override-grid md-cell--12 md-grid md-grid--no-spacing">
                  <div className="veros-status md-cell--6"> {getStatus(status)} </div>
                  <div className="veros-date md-cell--6 text-right"> {date}  </div>
                  <DataTable plain className="md-cell--12">
                    <TableHeader>
                      <TableRow>
                        <TableColumn style={{ maxWidth: 60 }}>Code</TableColumn>
                        <TableColumn style={{ width: "20%", minWidth: 200 }}>Action Message</TableColumn>
                        <TableColumn>Form Section</TableColumn>
                        <TableColumn style={{width: "20%"}}>Form Field</TableColumn>
                        <TableColumn>Property Affected</TableColumn>
                        <TableColumn grow={false} style={{ width: "20%", minWidth: 250, maxWidth: 600}}>Override Request</TableColumn>
                        <TableColumn grow={true} style={{ width: "20%", minWidth: 300 }}>Override Comment</TableColumn>
                        <TableColumn style={{ maxWidth: 100 }}>Override Date</TableColumn>
                        <TableColumn>Severity</TableColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {items.map(({ id, resultCode, resultMessage, formSection, formField, propertyAffected, severity,
                            selectedVerosOverrideTypeId, selectedOverrideComment, resolvedDate, choices, editable }) => (
                        <TableRow key={id}>
                          <TableColumn>{resultCode}</TableColumn>
                          <TableColumn>{resultMessage}</TableColumn>
                          <TableColumn>{checkIfEmpty(formSection, "N/A", "veros-no-override-message")}</TableColumn>
                          <TableColumn>{checkIfEmpty(formField, "N/A", "veros-no-override-message")}</TableColumn>
                          <TableColumn>{checkIfEmpty(propertyAffected, "N/A", "veros-no-override-message")}</TableColumn>
                          {readOnly || choices.length < 2 
                            ? <TableColumn>{this.getChoice(choices, selectedVerosOverrideTypeId, severity)}</TableColumn>
                            : <SelectFieldColumn 
                                  menuItems={this.buildMenu(choices)} 
                                  defaultValue={selectedVerosOverrideTypeId}  
                                  onChange={(e) => this.changedOverrideType(id, e)}
                                />
                          }
                          {readOnly || choices.length < 2
                            ? <TableColumn><span className="veros-no-override-message">No override comment.</span></TableColumn>
                            : <EditDialogColumn
                              inline
                              defaultValue={selectedOverrideComment || ""}
                              onChange={(e) => this.changedOverrideComment(id, e)}
                              disabled={readOnly || !editable}
                            />
                          }
                          <TableColumn>{dateTimeToString(resolvedDate)}</TableColumn>
                          <TableColumn>{checkIfEmpty(severity, "N/A", "veros-no-override-message")}</TableColumn>
                        </TableRow>
                      ))}
                    </TableBody>
                  </DataTable>
                  <div className="md-cell--12">
                    <br />
                    <Button
                      raised
                      primary
                      type="submit"
                      children="Save Overrides"
                      disabled={readOnly || invalid || pristine || submitting}
                      onClick={this.onSubmit}
                    />
                  </div>
                </div>
              :
                <div className="md-cell--12 veros-no-errors">{getStatus(status)}</div>
              }
          </CardText>
        </Card>
      </div>      
    );
  }
}
IssuesList.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  status: PropTypes.number.isRequired,
  readOnly: PropTypes.bool.isRequired,
  items: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  getControlMethods: PropTypes.func,
};

export { getStatus, IssuesList };